import React, { Component } from "react";
import { connect } from "react-redux";
import { getMessage } from "CONFIG/i18n";
import { Button, Container, Row, Col } from "reactstrap";
import Spinner from "COMPONENTS/Spinner/Spinner";
import { CONFIG, ERROR,USER_ADMISSION_STATUS } from "UTILS/Constants";
import { sessionActions as actionFactory, organisationAction } from "CONFIG/ActionFactory";
import { selectSessionKey,selectEndUserToken } from "../MainLayout/selectors";
import { selectQRLicenseKey } from "../QRCode/QRCodeComponent/QRCodeSelector";
import { leaveSessionAction } from "CONFIG/ActionFactory";
import * as log from "loglevel";

// Assets
import img_header_logo from "ASSETS/Images/img_header_logo.webp";

class ReJoinContainer extends Component {
  constructor(props) {
    super(props);
    log.setLevel("error");
  }
  state = {
    errorMessage: "",
    spinnerVisibility: false
  };
  componentDidMount() {
    console.log("############# ReJoinContainer componentDidMount");
    // Get sessionKey to Join
    // Clear all endpoint and reducers
    leaveSessionAction.localSessionAllDataCleanUp();
    
    // setTimeout(() => {
    //   this.handleProceed();
    // }, 1000);

    this.handleProceed();
  }

  renderSprinner = () => {
    return <Spinner showSpinner={this.state.spinnerVisibility} />;
  }

  handleProceed = () => {
    console.log("########## RejoinContainer handleProceed");
    this.setState({spinnerVisibility: true});
    actionFactory.joinSessionAction(this.props.sessionKey, this.props.uriIdentifier, true ,this.props.endUserToken).then(
      response => {
        console.log("########## RejoinContainer joinSessionAction");
        let logoUrl = response.data.data.logoUrl;
        if (!logoUrl) {
          logoUrl = img_header_logo;
        }
        organisationAction.setLogoUrl(logoUrl);
        this.setState({spinnerVisibility: false});    
        if(response.data.data.admissionStatus === USER_ADMISSION_STATUS.ADMITTED) {
          this.props.history.push(CONFIG.path.dashboard);
        } else {
          if(response.data.data.sessionType === "QR_CODE") {
            this.props.history.push(`${CONFIG.path.startSession}?licenseKey=${this.props.qrLicenseKey}`);
          } else {
            this.props.history.push(CONFIG.path.waitingRoom);
          }
        }
      },
      error => {
        this.setState({
          errorMessage: error.code === ERROR.SERVER_UNREACHABLE_ERROR ? "" : error.code,
          spinnerVisibility: false
        });
        if(error.code === ERROR.INVALID_SESSION){
          this.props.history.push(CONFIG.path.sessionEnded)
        }
        if(error.code === ERROR.USER_EVICTED_BY_AGENT) {
          this.props.history.push(CONFIG.path.userEvicted)
        }
      }
    );
  };

  render() {
    return (
      <div>
        {this.renderSprinner()}
        <section className="bgColor">
          <Container>
            <Row>
              <Col md="12" lg="12">
                <h4 className="text-center pt-5">{getMessage("REJOINING")}</h4>
                {/* {this.state.errorMessage ? (
                  <Col className="text-center">
                    <div className="errors ">
                      <label className="pt-lg-2">
                        {/* {this.state.errorMessage} */}
                {/* {getMessage("PLEASE_TRY_AGAIN")} 
                      </label>
                    </div>
                  </Col>
                ) : null} */}
                <Row className="pt-2">
                  <Col className="text-center">
                    <Button
                      className="customBtn whiteOnClick rejoinBtn"
                      onClick={this.handleProceed}
                    >
                      {getMessage("TRY_AGAIN")}
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col className="text-center">
                    <div className="errors ">
                      <label className="pt-lg-2">
                        {getMessage(this.state.errorMessage)}
                      </label>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    sessionKey: selectSessionKey(state),
    endUserToken: selectEndUserToken(state),
    qrLicenseKey: selectQRLicenseKey(state),
    uriIdentifier: state.UserReducer.uriIdentifier
  };
};
export default connect(mapStateToProps)(ReJoinContainer);
